import React, { ReactNode } from "react";

import classNames from "classnames";

import "./PillSelector.scss";

type Option = {
  label: string | ReactNode;
  value: string | null;
  disabled?: boolean;
};

type Props = {
  options: Option[];
  value?: string;
  defaultValue?: string;
  onChange: (value: string | null) => void;
  className?: string;
  disabled?: boolean;
};

export const PillSelector: React.FC<Props> = ({
  options,
  value,
  onChange,
  className,
  disabled,
}) => {
  return (
    <div role="radiogroup" className={classNames("pill-selector", className)}>
      {options.map((option) => {
        const isSelected = option.value === value;

        return (
          <button
            key={option.value}
            role="radio"
            aria-checked={isSelected}
            disabled={option.disabled || disabled}
            onClick={() => onChange(option.value)}
            className={classNames("pill-selector__button", {
              "pill-selector__button--selected": isSelected,
            })}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};
